import { CommonModule } from '@angular/common';
import { MatAutocompleteModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable, Component, EventEmitter, Input, Output, defineInjectable, NgModule } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, filter, tap } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/quicksearch-lib.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var QuicksearchLibService = /** @class */ (function () {
    function QuicksearchLibService() {
    }
    QuicksearchLibService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    QuicksearchLibService.ctorParameters = function () { return []; };
    /** @nocollapse */ QuicksearchLibService.ngInjectableDef = defineInjectable({ factory: function QuicksearchLibService_Factory() { return new QuicksearchLibService(); }, token: QuicksearchLibService, providedIn: "root" });
    return QuicksearchLibService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/quicksearch-lib.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var QuicksearchLibComponent = /** @class */ (function () {
    function QuicksearchLibComponent() {
    }
    /**
     * @return {?}
     */
    QuicksearchLibComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    QuicksearchLibComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ilp-quicksearch-lib',
                    template: "\n    <p>\n      quicksearch-lib works!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    QuicksearchLibComponent.ctorParameters = function () { return []; };
    return QuicksearchLibComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/quick-search/quick-search.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var QuickSearchComponent = /** @class */ (function () {
    function QuickSearchComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.quickSearchLabel = 'Quick-search';
        this.minSearchCharacters = 3;
        this.debounceTime = 400;
        this.quickSearchInputText = new EventEmitter();
        this.quickSearchResultSelect = new EventEmitter();
    }
    /**
     * @return {?}
     */
    QuickSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._setupForm();
        this._setupAutoCompletion();
    };
    /**
     * @private
     * @return {?}
     */
    QuickSearchComponent.prototype._setupForm = /**
     * @private
     * @return {?}
     */
    function () {
        this._quickSearchForm = this.formBuilder.group({
            search_text: ['']
        });
    };
    /**
     * @private
     * @return {?}
     */
    QuickSearchComponent.prototype._setupAutoCompletion = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this._quickSearchForm) {
            this._setupForm();
        }
        this.quickSearchTextControl.valueChanges
            .pipe(tap((/**
         * @return {?}
         */
        function () {
            _this.quickSearchOptions = [];
            _this._isLoading = true;
        })), filter((/**
         * @param {?} value
         * @return {?}
         */
        function (value) { return value.length >= _this.minSearchCharacters; })), debounceTime(400)).subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this._emitSearchInputText(value);
        }));
    };
    /**
     * @private
     * @param {?=} value
     * @return {?}
     */
    QuickSearchComponent.prototype._emitSearchInputText = /**
     * @private
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        this.quickSearchInputText.emit(value);
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    QuickSearchComponent.prototype._emitSearchOptionSelect = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.quickSearchResultSelect.emit(value);
    };
    /**
     * @param {?} quickSearchOption
     * @return {?}
     */
    QuickSearchComponent.prototype.displayFn = /**
     * @param {?} quickSearchOption
     * @return {?}
     */
    function (quickSearchOption) {
        return quickSearchOption && quickSearchOption.label ? quickSearchOption.label : '';
    };
    /**
     * @param {?} value
     * @return {?}
     */
    QuickSearchComponent.prototype.onAutoCompleteOptionSelect = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._emitSearchOptionSelect(value);
    };
    Object.defineProperty(QuickSearchComponent.prototype, "quickSearchOptions", {
        set: /**
         * @param {?} quickSearchOptions
         * @return {?}
         */
        function (quickSearchOptions) {
            this._isLoading = false;
            this._quickSearchOptions$ = new Observable((/**
             * @param {?} observer
             * @return {?}
             */
            function (observer) { return observer.next(quickSearchOptions); }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickSearchComponent.prototype, "quickSearchTextControl", {
        get: /**
         * @return {?}
         */
        function () {
            return this._quickSearchForm.get('search_text');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickSearchComponent.prototype, "quickSearchForm", {
        get: /**
         * @return {?}
         */
        function () {
            return this._quickSearchForm;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickSearchComponent.prototype, "quickSearchOptions$", {
        get: /**
         * @return {?}
         */
        function () {
            return this._quickSearchOptions$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuickSearchComponent.prototype, "isLoading", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isLoading;
        },
        enumerable: true,
        configurable: true
    });
    QuickSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ilp-quick-search',
                    template: "<form [formGroup]=\"quickSearchForm\">\n\n    <mat-form-field class=\"quick-search-form-field\">\n        <mat-label>{{quickSearchLabel}}</mat-label>\n        <input matInput\n               type=\"text\"\n               placeholder=\"{{placeHolderText}}\"\n               [formControl]=\"quickSearchForm.controls['search_text']\"\n               [matAutocomplete]=\"auto\">\n\n        <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"onAutoCompleteOptionSelect($event.option.value)\"\n                          [displayWith]=\"displayFn\">\n\n            <!-- Loading indicator option -->\n            <mat-option *ngIf=\"isLoading\">\n                <mat-spinner class=\"spinner\" [diameter]=\"20\"></mat-spinner>\n            </mat-option>\n\n            <!-- Quicksearch results -->\n            <ng-container *ngFor=\"let quickSearchOption of quickSearchOptions$ | async\">\n                <mat-option [value]=\"quickSearchOption\">\n                    <span class=\"quick-search-hint\" *ngIf=\"quickSearchOption.hint\">{{quickSearchOption.hint}}</span>\n                    {{quickSearchOption.label}}\n                    <ng-container *ngIf=\"quickSearchOption.providers\">\n                        <span class=\"quick-search-provider-chip\" *ngFor=\"let provider of quickSearchOption.providers\">{{provider}}</span>\n                    </ng-container>\n                </mat-option>\n            </ng-container>\n\n        </mat-autocomplete>\n\n    </mat-form-field>\n</form>\n",
                    styles: [".quick-search-hint{display:block;font-size:12px;line-height:10px;color:#afafaf}.mat-option{line-height:25px}.quick-search-provider-chip{padding:2px 8px;font-size:70%;background-color:#e0e0e0}.quick-search-form-field{width:100%}"]
                }] }
    ];
    /** @nocollapse */
    QuickSearchComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    QuickSearchComponent.propDecorators = {
        placeHolderText: [{ type: Input }],
        quickSearchLabel: [{ type: Input }],
        minSearchCharacters: [{ type: Input }],
        debounceTime: [{ type: Input }],
        quickSearchInputText: [{ type: Output }],
        quickSearchResultSelect: [{ type: Output }],
        quickSearchOptions: [{ type: Input }]
    };
    return QuickSearchComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/quicksearch-lib.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var QuicksearchLibModule = /** @class */ (function () {
    function QuicksearchLibModule() {
    }
    QuicksearchLibModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [QuicksearchLibComponent, QuickSearchComponent],
                    imports: [
                        CommonModule,
                        MatFormFieldModule,
                        ReactiveFormsModule,
                        BrowserAnimationsModule,
                        MatAutocompleteModule,
                        MatInputModule,
                        MatProgressSpinnerModule
                    ],
                    exports: [QuicksearchLibComponent, QuickSearchComponent]
                },] }
    ];
    return QuicksearchLibModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: quicksearch-lib.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { QuicksearchLibService, QuicksearchLibComponent, QuicksearchLibModule, QuickSearchComponent };

//# sourceMappingURL=quicksearch-lib.js.map